export default __webpack_public_path__ + "chevron-arrow-down.png";